import 'shared_js/runtime-env';
import { detectWebpSupport } from 'shared_js/detect-webp-support';
import logger from 'shared_js/logger';

import createApp from './createApp';

import dopeStore from './stores/dope';
import headerStore from './stores/header';

const APP_ID = '#vm__white-header-dweb';
const MAX_INIT_RETRY = 60;

const momshipHeader = document.querySelector('.c-outer-wrapper');

if (momshipHeader) {
  momshipHeader.style.paddingTop = '117px';
}

export default async function init({
  appMountedCallback = function () {},
} = {}) {
  const { USER, Vue } = window;
  const IDENTITY = USER.identity;
  const canUseWebp = detectWebpSupport();
  let { APP, API, axios, STORE } = window;

  const initialState = window.__HEADER_DESKTOP_STATE__;
  const context = { APP, USER, STORE, API, axios, IDENTITY };

  window.STORE.registerModule('dope', dopeStore(context));
  window.STORE.registerModule('header', headerStore(context));

  if (initialState) {
    if (initialState.category && initialState.category.list) {
      window.STORE.commit('category/updateList', initialState.category.list);
    }
  }

  if (USER.id) {
    window.STORE.dispatch('cart/getCarts');
  }

  const { app } = createApp({
    Vue,
    vuexStore: window.STORE,
    USER,
    appMountedCallback,
    canUseWebp,
    originalUrl: window.location.href,
  });

  app.$mount(APP_ID);
}

function retryAbleInit(n = 0) {
  try {
    init();
  } catch (e) {
    if (n < MAX_INIT_RETRY) {
      setTimeout(() => {
        retryAbleInit(n + 1);
      }, 1000);
    } else {
      logger.error(e);
    }
  }
}

if (window.APP.appReadyPromise) {
  window.APP.appReadyPromise.then(() => {
    retryAbleInit();
  });
} else {
  retryAbleInit();
}
